import { getFullKey } from '../services/LocalStorage';
import { useBrowserStorage } from './useBrowserStorage';

/**
 * This can be used instead of useState to store information in localStorage. The state is shared between all uses
 * of the hook with the same storageKey, even across tabs. This means that setting the value in one component causes a
 * re-render of all other components using the hook, with the new value. Even when they're in other browser tabs.
 *
 * @param storageKey This identifies the storage object within SI. It's prefixed properly behind the scenes, so pick a short name
 * @param init If there is nothing stored already, use this as the default value (similar to how useState works)
 */
export default function useLocalStorage<T>(storageKey: string, init: T): [T, (o: T) => void] {
    return useBrowserStorage(storageKey, init, {
        storage: window.localStorage,
        area: 'local',
        getKey: getFullKey,
    });
}
